import { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Col, Row } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import SignInHook from './InformalSignUpHook';
import '../signup.css';

class InformalSignup extends Component {
  state = {
    title: 'Informal Sector',
    hideForm: true,
    nationalID: ' ',
  };

  handleVerifyMemberId = () => {
    if (this.state.nationalID.length >= 12) {
      this.setState({ hideForm: false });
    } else {
      console.log('empty');
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
  };

  render() {
    const {
      title,
      hideForm,
    } = this.state;

    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className="page-title">{title}</h1>
          <div className="container-register">
            <Row>
              <Col lg="4">
                <div className="card">
                  <div className="card-header">
                    About
                  </div>
                  <div className="card-body">
                    <p>
                      Shirika limeanzisha mpango wa kitaifa wa hifadhi ya jamii kwa sekta isiyo rasmi (National Informal
                      Sector Scheme – NISS) kwa ajili ya kuwahudumia wanachama waliojiajiri wenyewe kwa urahisi,
                      ufanisi na weledi.
                    </p>
                    <p>
                      Once you complete registration. An email with activation
                      link and login details will be sent to your email shortly. Follow instructions indicated in the
                      email to register your user account for NSSF Member Self Service Portal.
                    </p>
                    <p><b>Have account? Click button below</b></p>
                    <Link to="/login" className="btn btn-green btn-block px-4 gap-3">
                      Login
                    </Link>
                  </div>
                </div>
              </Col>
              <Col lg="8">
                <div className="card">
                  <div className="card-header">
                    Instructions
                  </div>
                  <div className="card-body">
                    { hideForm && (
                      <div>
                        <strong>STEP 1</strong>
                        <p>
                          To be able to register for Informal Sector Scheme one has to provide a valid
                          <strong> National ID </strong>(NIDA No) with the correct email address and mobile number.
                        </p>
                        <div className="div-block">
                          <p>Please fill in your<strong> National ID </strong>(NIDA No)</p>
                          <NumberFormat
                            className="number-format"
                            format="########-#####-#####-##"
                            onValueChange={ (values) => {
                              const { value } = values;
                              this.setState({ nationalID: value });
                            }}
                          />
                        </div>
                        <button type="button"
                                className="btn btn-green btn-block px-4 gap-3"
                                onClick={ this.handleVerifyMemberId }
                        >Verify National ID</button>
                      </div>
                    ) }
                    { !hideForm && (<SignInHook/>) }
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </main>
      </>
    );
  }
}

export default InformalSignup;
